import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  ReturnToSupplierHistoryListContent,
  ReturnToSupplierHistorySearchCriteria
} from '../../model/return-to-supplier-history.model';

export const ReturnToSupplierHistoryAction = createActionGroup({
  source: 'Return To Supplier History',
  events: {
    RequestList: props<{ criteriaObj: ReturnToSupplierHistorySearchCriteria }>(),
    ResponseList: props<{ data: Pagination<ReturnToSupplierHistoryListContent> }>(),
    ClearFilters: emptyProps(),
    RequestPrint: props<{ returnNo: string }>(),
    ResponsePrint: emptyProps()
  }
});
